"use strict";
exports.__esModule = true;
exports.reflectSpecifics = void 0;
var types_1 = require("../families/algorand/types");
var types_2 = require("../families/bitcoin/types");
var types_3 = require("../families/celo/types");
var types_4 = require("../families/cosmos/types");
var types_5 = require("../families/crypto_org/types");
var types_6 = require("../families/elrond/types");
var types_7 = require("../families/ethereum/types");
var types_8 = require("../families/filecoin/types");
var types_9 = require("../families/neo/types");
var types_10 = require("../families/polkadot/types");
var types_11 = require("../families/ripple/types");
var types_12 = require("../families/solana/types");
var types_13 = require("../families/stellar/types");
var types_14 = require("../families/tezos/types");
var types_15 = require("../families/tron/types");
var reflectSpecifics = function (declare) { return [
    (0, types_1.reflect)(declare),
    (0, types_2.reflect)(declare),
    (0, types_3.reflect)(declare),
    (0, types_4.reflect)(declare),
    (0, types_5.reflect)(declare),
    (0, types_6.reflect)(declare),
    (0, types_7.reflect)(declare),
    (0, types_8.reflect)(declare),
    (0, types_9.reflect)(declare),
    (0, types_10.reflect)(declare),
    (0, types_11.reflect)(declare),
    (0, types_12.reflect)(declare),
    (0, types_13.reflect)(declare),
    (0, types_14.reflect)(declare),
    (0, types_15.reflect)(declare),
]; };
exports.reflectSpecifics = reflectSpecifics;
//# sourceMappingURL=types.js.map